const DASHBOARD = ['activity', 'conditional_page_render', 'your-program', 'your-program::rich'];

export { DASHBOARD };
